import request from './api';
import {
  API_DEPARTMENT_ID,
  API_DEPARTMENT_HCM,
  API_DEPARTMENT_DATA,
  API_CMS_DOCUMENTS,
  API_PUBLIC_DOCUMENTS,
  API_FOLDER,
  API_DEPARTMENT_TEAM,
  API_GROUPS
} from '../constants/api';

/** Search department */
/**
 * Retrieves the id of the department.
 * @param {string} name
 * @param {string} orderby    NAME
 * @param {string} size         10
 * @param {string} page          0
 * @param {string} direction   ASC
 */
// orderby, name,lastname,idDepartment,extension,phones,size,page,direction
export const getDepartmentId = ({ name }) =>
  request(API_DEPARTMENT_ID, {
    method: 'GET',
    params: {
      orderby: 'NAME',
      name,
      size: 10,
      page: 0,
      direction: 'ASC'
    }
  });

export const getDepartmentNameHCM = ({ name }) =>
  request(API_DEPARTMENT_HCM, {
    method: 'GET',
    params: {
      name
    }
  });

export const getDepartmentDocsParents = () =>
  request(`${API_CMS_DOCUMENTS}/associationfolders`, {
    method: 'GET'
  });

export const getDepartmentDocs = departmentId =>
  request(`${API_CMS_DOCUMENTS}/association/${departmentId}`, {
    method: 'GET'
  });

export const getDepartmentData = departmentId =>
  request(`${API_DEPARTMENT_DATA}/${departmentId}`, {
    method: 'GET'
  });

export const getDepartmentTeam = departmentId =>
  request(API_DEPARTMENT_TEAM.replace('0000', departmentId), { method: 'GET' });

export const getDepartmentFolder = (folderId, associationId) =>
  request(`${API_CMS_DOCUMENTS}/folders`, {
    method: 'GET',
    params: {
      folderId,
      associationId
    }
  });

export const postNewFolder = (data, parentFolderId) =>
  request(`${API_FOLDER}`, {
    method: 'POST',
    data: {
      ...data
    },
    params: {
      parentFolderId
    }
  });

export const findNewFolder = folderId =>
  request(`${API_FOLDER}/${folderId}`, {
    method: 'GET'
  });

export const deleteNewFolder = folderId =>
  request(`${API_FOLDER}/${folderId}`, {
    method: 'DELETE'
  });

export const uploadDocument = formData =>
  request(`${API_PUBLIC_DOCUMENTS}/upload`, {
    method: 'POST',
    data: formData,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  });

export const createStructure = formData =>
  request(`${API_FOLDER}/zipFolder`, {
    method: 'POST',
    data: formData,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  });

export const postDocument = data =>
  request(`${API_PUBLIC_DOCUMENTS}`, {
    method: 'POST',
    data: {
      ...data
    }
  });

export const findDocument = documentId =>
  request(`${API_PUBLIC_DOCUMENTS}/${documentId}`, {
    method: 'GET'
  });

export const deleteDocument = documentId =>
  request(`${API_PUBLIC_DOCUMENTS}/${documentId}`, {
    //  request(
    //    `http://localhost:8088/intranetcms/v1/api/public/documents/${documentId}`,
    //    {
    method: 'DELETE'
  });

export const getDocumentsAndFolders = folderId =>
  request(`${API_PUBLIC_DOCUMENTS}`, {
    method: 'GET',
    params: {
      folderId
    }
  });

export const getFolderPath = folderId =>
  request(`${API_FOLDER}/${folderId}/path`, {
    method: 'GET'
  });

export const checkUserInGroup = groupIdList =>
  request(`${API_GROUPS}userInGroupIdList`, {
    method: 'GET',
    params: {
      groupIdList
    }
  });
